import { render } from "./IconCircleExclamation.vue?vue&type=template&id=13325083"
import script from "./IconCircleExclamation.vue?vue&type=script&lang=js"
export * from "./IconCircleExclamation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bapman/Sites/telemac-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__